import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { ProductSettingTypes } from 'constants/enums/productTypes'
import './FooterLoggedOut.scss'
import AppContext from 'contexts/AppContext'
import { footerValues } from 'constants/values/footerValues'
import { IFooter } from 'interfaces/i-footer'

/**
 * Footer not dependent on type of px application product
 * @returns jsx element Footer for logged out pages
 */
export function FooterLoggedOut() {
	const { market } = useContext(AppContext)
	const { t } = useTranslation()
	const [footerContent, setFooterContent] = useState<IFooter>(footerValues[0])

	const getFooterValues = useCallback(() => {
		console.log(footerValues)
		footerValues.find(
			(val) => val.country === market && setFooterContent(val),
		)
	}, [market])

	useEffect(() => {
		getFooterValues()
	}, [getFooterValues])

	return (
		<div id="footer-logged-out">
			<Row>
				<Col>
					<div id="footer-copyright">
						{`© ${new Date().getFullYear()} ${footerContent?.copyRight}`}
					</div>
					<div id="footer-contact">
						{footerContent?.productSpecific.map((value, key) => {
							if (
								value.productType === ProductSettingTypes.All ||
								footerContent.country === 'no'
							) {
								return (
									<div key={key} className="footer-contact-entry">
										<div className="footer-contact-phone-number">
											<a
												href={`tel:${value.contactInformation.phoneNumber}}`}>
												{value.contactInformation
													.phoneNumber +
													(footerContent.country ===
													'no'
														? value.productType ===
															ProductSettingTypes.Loan
															? ` (${t('Loan')})`
															: ` (${t('CreditCard')})`
														: '')}
											</a>
											{','}
										</div>
										{footerContent.country === 'it' && (
											<div className="footer-contact-email">
												<a
													href={`mailto:${value.contactInformation.email}`}>
													{
														value.contactInformation
															.email
													}
												</a>
												{','}
											</div>
										)}
										{footerContent.country === 'it' &&
											value.contactInformation
												.openingHours && (
												<div className="footer-contact-opening-hours">
													{
														value
															.contactInformation
															.openingHours
													}
													{','}
												</div>
											)}
									</div>
								)
							} else return null
						})}
						{footerContent !== undefined &&
							Object.entries(footerContent?.address).map(
								([key, value]) => {
									return (
										value +
										(key === 'zipCodeAndCity' ? '' : ', ')
									)
								},
							)}
					</div>
				</Col>
			</Row>
		</div>
	)
}
